var map = {
	"./decidim/avatar-multiuser.png": 69914,
	"./decidim/brands/facebook.svg": 96380,
	"./decidim/brands/google.svg": 64821,
	"./decidim/brands/twitter-x.svg": 11190,
	"./decidim/cc-badge.png": 45412,
	"./decidim/decidim-logo.svg": 24072,
	"./decidim/default-avatar.svg": 33456,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 80844,
	"./decidim/icons.svg": 30539,
	"./decidim/pattern.png": 31148,
	"./decidim/placeholder-card-g.svg": 48457,
	"./decidim/placeholder-card-l.svg": 89474,
	"./decidim/placeholder.jpg": 2369,
	"./decidim/remixicon.symbol.svg": 90917,
	"./decidim/vendor/social-share-button/douban.svg": 7988,
	"./decidim/vendor/social-share-button/email.svg": 82769,
	"./decidim/vendor/social-share-button/facebook.svg": 60823,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 73801,
	"./decidim/vendor/social-share-button/hacker_news.svg": 43521,
	"./decidim/vendor/social-share-button/linkedin.svg": 13393,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 37938,
	"./decidim/vendor/social-share-button/pinterest.svg": 30695,
	"./decidim/vendor/social-share-button/reddit.svg": 28715,
	"./decidim/vendor/social-share-button/telegram.svg": 84526,
	"./decidim/vendor/social-share-button/tumblr.svg": 78221,
	"./decidim/vendor/social-share-button/twitter.svg": 22752,
	"./decidim/vendor/social-share-button/vkontakte.svg": 88846,
	"./decidim/vendor/social-share-button/wechat.svg": 77993,
	"./decidim/vendor/social-share-button/whatsapp.svg": 68305,
	"./decidim/vendor/social-share-button/x.svg": 64505,
	"./decidim/vendor/social-share-button/xing.svg": 75415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47245;